import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import Loadingmini from '../components/loadingmini';
import { Flex, View, Text, Button, Heading} from '@aws-amplify/ui-react';

export default function Vehiclevlo({vehicle, fleetCode}) {
  const [is_loading, updateIsLoading] = React.useState(false);
  const [vlo_url, updateVloUrl] = React.useState(false);
  const [myerror, updateMyerror] = React.useState(false);
  const [mysuccess, updateMySuccess] = React.useState(false);
  const [showOptions, updateShowOptions] = React.useState(false);
  const [showUploadVlo, updateShowUploadVlo] = React.useState(false);
	const [selectedFile, setSelectedFile] = useState();
  const [presigned_url, updatePresignedUrl] = React.useState("");
  const [new_document_name, updateNewDocumentName] = React.useState("");
	const [isSelected, setIsSelected] = useState(false);

  async function submitVlo() {
    updateIsLoading(true);
    if(!isSelected)
    {
      updateMyerror("Please select a file before submitting.")
      updateIsLoading(false);
      return;
    }
    let session = await Auth.currentSession() 
    fetch(presigned_url, {
        method:'PUT',
        body:selectedFile,
        headers: {
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Origin': '*'
        }
    }).then((res) => {
        //console.log('res:'+JSON.stringify(res))
        let accessToken = session.getAccessToken()
        let jwt = accessToken.getJwtToken()
        const myInit = {queryStringParameters:{ 
            back_end: process.env.REACT_APP_BACKEND, 
            jwt:jwt, 
            api_endpoint: "api3:vehicles:documents",
            request_type: "GET",
            kind: "vlo",
            document_name: new_document_name,
            vehicle_id: vehicle['resp'][0]['car_id'],
            fleet_code:fleetCode
        }};
        //console.log('myInit:'+JSON.stringify(myInit))
        try {
            API.get('adminWebTools','/ago',myInit).then((res3) => {
                console.log(JSON.stringify(res3))
                updateMySuccess(true)
            });
        } catch (e) {
            var statusString = "Error uploading file: " + e;
            updateMyerror(statusString);
        }
    })
    updateIsLoading(false);
  }

	const updateFile = (event) => {
		setSelectedFile(event.target.files[0]);
		setIsSelected(true);
	};

  async function getPresignedUrl() {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint:"api3:vehicles:documents",
        request_type:"GET",
        kind:"vlo",
        vehicle_id: vehicle['resp'][0]['car_id'],
        fleet_code:fleetCode
    }};
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        //console.log(JSON.stringify(res))
        updatePresignedUrl(res["presigned_url_upload"]);
        updateNewDocumentName(res["new_document_name"]);
    }
    catch (e) {
        const res = {status:"Error: " + JSON.stringify(e)}
        updateMyerror(res)
    }
    updateIsLoading(false)
  }

  async function getImageUrl() {
    updateIsLoading(true)
    //console.log('generating vlo for car ' + vehicle['resp'][0]['car_id'] + "...");
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{ 
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint:"api3:vehicles:documents",
        request_type:"GET",
        kind:"vlo",
        view:true,
        vehicle_id: vehicle['resp'][0]['car_id'],
        fleet_code:fleetCode,
    }};
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        //console.log(JSON.stringify(res))
        if('vehicle_info' in res === false)
        {
          updateMyerror("no vehicle_info in res")
          updateIsLoading(false)
          return
        }
        if('vlo_url' in res['vehicle_info'] === false)
        {
          updateMyerror("no vlo_url in vehicle_info")
          updateIsLoading(false)
          return
        }
        updateVloUrl(res['vehicle_info']['vlo_url'])
        updateShowUploadVlo(false);
        updateMyerror(false)
        updateMySuccess(false)
        updateIsLoading(false)
        return
    }
    catch (e) {
        console.log(JSON.stringify(e))
        updateMyerror(JSON.stringify(e));
        updateIsLoading(false)
        return
    }
  }


  useEffect(() => {
    getPresignedUrl();
  },[])

  return (
    is_loading ? <Loadingmini /> : 
      <Flex
        direction="column"
      >
        <View style={{width:"100%"}}>
          <Flex direction="column" gap="1rem" >
            <Flex direction="column">
                { myerror ? <View>
                          <Heading level={4}>Whoops!</Heading>
                          <Text>We ran into an error processing your request:</Text>
                          <Text>{typeof myerror === 'string' ? myerror : JSON.stringify(myerror)}</Text>
                        <Button onClick={() => getImageUrl()}>TRY AGAIN</Button>
                    </View>
                  :
                  mysuccess ? <View>
                          <Heading level={4}>Success!</Heading>
                          <Text>Your VLO has been uploaded.</Text>
                        <Button onClick={() => getImageUrl()}>VIEW VLO</Button>
                    </View>
                  :
                  vlo_url ? 
                    <View>
                      <Text><a href={vlo_url} target='_blank'>CLICK TO DOWNLOAD VLO</a></Text>
                      <br />
                      <Button onClick={() => updateVloUrl(false)}>CANCEL</Button>
                    </View>
                  : showUploadVlo ?
                    <View>
                      <Heading level={2}>Upload VLO</Heading>
                      <input type="file" name="file" onChange={updateFile} accept=".jpg, .png, .jpeg" />
                      {isSelected ? (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}>
                          <Text>Filename: {selectedFile.name}</Text>
                          <Text>Filetype: {selectedFile.type}</Text>
                          <Text>Size in bytes: {selectedFile.size}</Text>
                          <Text>
                            lastModifiedDate:{' '}
                            {selectedFile.lastModifiedDate.toLocaleDateString()}
                          </Text>
                        </View>
                      ) : (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}><Text>Select a file to show details</Text></View>
                      )}
                      <br />
                      <Button onClick={() => submitVlo()}>SUBMIT</Button>
                      <br />
                      <br />
                      <Button onClick={() => updateShowUploadVlo(false)}>CANCEL</Button>
                    </View>
                  : showOptions ?
                    <View>
                      <Button onClick={() => getImageUrl()}>VIEW VLO</Button>
                      <br/>
                      <br/>
                      <Button onClick={() => updateShowUploadVlo(true)}>UPLOAD VLO</Button>
                      <br/>
                      <br/>
                      <Button onClick={() => updateShowOptions(false)}>MINIMIZE VLO</Button>
                    </View>
                  : <Button onClick={() => updateShowOptions(true)}>VLO</Button>
                }
            </Flex>
          </Flex>
        </View>
      </Flex>
  );
}